import React from "react"
import Wrapper from "../components/Wrapper"
import Image from "../components/Image"

const PageFooter = () => (
  <footer className="px-24 pt-12 pb-4 text-center text-white text-base sm:px-12 xs:px-6">
    <Wrapper
      size="m"
      className="mx-auto"
    >
      <nav
        role="navigation"
        className="flex flex-wrap justify-center"
      >
        <a className="mr-3" target="_blank" rel="noopener" href="https://bonum.no">Selskap</a>
        <a className="mx-3" target="_blank" rel="noopener" href="https://bonum.no/utvikling">Utvikling</a>
        <a className="mx-3" target="_blank" rel="noopener" href="https://bonum.no/prosjekter">Prosjekter</a>
        <a className="mx-3" target="_blank" rel="noopener" href="https://bonum.no/entreprise">Entreprise</a>
        <a className="mx-3" target="_blank" rel="noopener" href="https://bonum.no/ansatte">Ansatte</a>
        <a className="mx-3" target="_blank" rel="noopener" href="https://bonum.no/karriere">Karriere</a>
        <a className="ml-3" target="_blank" rel="noopener" href="https://bonum.no/media">Media</a>
      </nav>

      <nav
        role="navigation"
        className="mx-auto my-4"
      >
        <a className="mr-2 inline-block" target="_blank" rel="noopener" href="https://facebook.com/BonumNO">
          <Image src="img/facebook.png" alt="Bonum på Facebook" className="w-4" />
        </a>
        <a className="mx-2 inline-block" target="_blank" rel="noopener" href="https://twitter.com/BonumAS">
          <Image src="img/twitter.png" alt="Bonum på Twitter" className="w-4" />
        </a>
        <a className="mx-2 inline-block" target="_blank" rel="noopener" href="https://instagram.com/bonum.no">
          <Image src="img/instagram.png" alt="Bonum på Instagram" className="w-4" />
        </a>
        <a className="mx-2 inline-block" target="_blank" rel="noopener" href="https://linkedin.com/company/Bonum-AS">
          <Image src="img/linkedin.png" alt="Bonum på LinkedIn" className="w-4" />
        </a>
        <a className="ml-2 inline-block" target="_blank" rel="noopener" href="https://www.youtube.com/channel/UC78IXbQ1FDoR7-34Hxe26WA">
          <Image src="img/youtube.png" alt="Bonum på Youtube" className="w-4" />
        </a>
      </nav>
    </Wrapper>

    <p className="mt-4">
      Bonum © 2019. <a target="_blank" rel="noopener" href="https://bonum.no/personvern">Personvern.</a>
    </p>
  </footer>
)

export default PageFooter
